import { api_without_cancellation } from "../../../../api/api";
import { getCaseId, getClientId } from "../../../../Utils/helper";

export const uploadCasePhotos = async (
  files,
  attachmentForFile,
  { onFileProgress, caseId = getCaseId(), clientId = getClientId() } = {}
) => {
  const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";
  let uploaded = 0;
  let failed = 0;

  for (const [index, file] of Array.from(files || []).entries()) {
    try {
      onFileProgress?.(index, { status: "uploading", progress: 0 });
      const formData = new FormData();
      formData.append("file", file);
      const response = await api_without_cancellation.post(
        `${origin}/api/upload_photo/${clientId}/${caseId}/`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: ({ loaded, total }) => {
            if (total) {
              onFileProgress?.(index, {
                progress: Math.min(95, Math.round((loaded / total) * 95)),
              });
            }
          },
        }
      );
      const photoId = response.data?.doc?.id;
      if (!photoId) throw new Error("The upload did not return a photo.");

      onFileProgress?.(index, { status: "saving", progress: 95 });
      const attachment = await api_without_cancellation.post("/api/attach_photo_to_page/", {
        page_id: null,
        slot_id: null,
        panel_id: null,
        model_name: "",
        ...attachmentForFile?.(index),
        case_id: caseId,
        photo_id: photoId,
      });
      if (attachment.status !== 200 && attachment.status !== 201) {
        throw new Error("The photo could not be attached.");
      }
      uploaded += 1;
      onFileProgress?.(index, { status: "completed", progress: 100 });
    } catch (error) {
      failed += 1;
      onFileProgress?.(index, {
        status: error.code === "ERR_CANCELED" ? "cancelled" : "failed",
        error: error.response?.data?.error || error.message || "Upload failed",
      });
      console.error("Photo upload failed:", error);
    }
  }

  return { uploaded, failed };
};
